module.exports = __webpack_public_path__ + "static/media/progress_header_2.10972257.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/progress_header_2.svg
// module id = 654
// module chunks = 0